import React from 'react';
import IconBarChart from '../Icons/IconBarChart';
import './Rank.less';

export type RankProps = {
  order: string;
};

const Rank: React.FC<RankProps> = ({ order, ...props }) => {
  const classNames = ['t-rank-container'];

  return (
    <div className={classNames.join(' ')}>
      <span>
        <IconBarChart />
      </span>
      <span className="t-rank-order">{order}</span>
      <span>
        <IconBarChart />
      </span>
    </div>
  );
};

export default Rank;
